import ProgramacaoLista from './ProgramacaoLista';

export default ProgramacaoLista;